import { uuidRegExpString } from '~/utils/Url';

const WORKSPACE_AGENT_UUID_PATTERN = new RegExp(`^${uuidRegExpString}$`, 'i');

export const isWorkspaceAgentUuid = (value: string): boolean => WORKSPACE_AGENT_UUID_PATTERN.test(value);
